<template>
  <div class="tb-form-group">
    <label class="tb-label">Animation</label>

    <select
      class="tb-select"
      data-entity="producer-editor-animation"
      data-test="display-editor-animationDropdown"
      @change="$emit('input', $event.target.value)"
    >
      <option
        v-for="option in options"
        :key="option"
        :value="option"
        :selected="value === option"
      >
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
const AnimationOptions = [
  'Slide',
  'Bounce',
  'Roll',
  'Flip',
  'Fade',
  'Zoom',
  'Swing',
  'Fly',
];

export default {
  props: {
    value: {
      type: String,
      default: 'Slide',
    },

    options: {
      type: Array,
      default: () => AnimationOptions,
    },
  },

  emits: ['input'],
};
</script>
